import styled from '@emotion/styled';

export const TerminalNodeRoot = styled('div')<{
  size: number;
}>(({ size }) => ({
  width: size,
  height: size,
  position: 'relative',
}));

export const TerminalNodeCenter = styled('div')<{
  size: number;
  color: string;
}>(({ size, color }) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  width: size,
  height: size,
  borderRadius: '50%',
  backgroundColor: color,
  transform: 'translate(-50%, -50%)',
}));

export const TerminalNodeWrapper = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
});

export const TerminalHandleStyle = (size: number) => ({
  left: '50%',
  top: '50%',
  transform: 'translate(-50%, -50%)',
  width: size,
  height: size,
  border: 'none',
  background: 'transparent',
});
